<div id="verify_container">
  <section>
    <nes-heading tag="h1" size="6xl" [cypress]="'page_title'" class="nes-mb-3">
      {{ "VERIFY.TITLE" | translate }}
    </nes-heading>
    <nes-text>
      {{ "VERIFY.SUB_TEXT" | translate }}

    </nes-text>
    <nes-divider class="nes-my-5"></nes-divider>
  </section>
  <section>
    <bca-company-info [company]="company$ | async" (edit)="onEditCompany()">
    </bca-company-info>
  </section>
  <section class="mt-3">
    <bca-product-summary></bca-product-summary>
  </section>
  <section class="mt-3">
    <bca-action-code
      [actionCode]="actionCode$ | async"
      (add)="onActionCodeAdd($event)"
      (remove)="onActionCodeDelete()"
      (error)="onActionCodeError($event)"
    >
    </bca-action-code>
  </section>

  <div>
    <div>
      <a
        (click)="previousRoute()"
        [cypress]="'previous_page'"
        class="backArrowLink backArrowLink--button actionBar__item"
      >
        <span class="backArrowLink__text">{{ "BUTTON.BACK" | translate }}</span>
      </a>
    </div>
    <div
      class="nes-flex nes-w-full nes-justify-between nes-items-center nes-flex-wrap"
    >
      <nes-button
        [disabled]="!(allowNewProduct$ | async)"
        variant="tertiary"
        icon-leading="plus-circle"
        type="button"
        (click)="addNewProduct()"
      >
        {{ "BUTTON.ADD_PRODUCT" | translate }}
      </nes-button>
      <nes-button
        [cypress]="'next_page'"
        variant="brand"
        nes-id="to_agreement_page"
        id="to_agreement_page"
        (click)="nextRoute()"
      >
        <span class="s-hidden m-visible">
          {{ "VERIFY.BUTTON.PAY_DESKTOP" | translate }}
        </span>
        <span class="s-visibile m-hidden">
          {{ "VERIFY.BUTTON.PAY_MOBILE" | translate }}
        </span>
      </nes-button>
    </div>
  </div>
</div>
